export default __webpack_public_path__ + "535a6cf662596b3bd6a6e5b877286df5.woff2";